// bundleDuplicates.ts
import { api } from '../core';
import { BUNDLE_DUPLICATES_TAG } from '../constants';
import { ServerBundleType } from '../types';
export interface BundleDuplicateItem {
  bundleType: ServerBundleType;
  categoryName: string;
  documentName: string;
  duplicateGroupId: string;
  pageId: string;
  pageNumber: number;
  providerName: string;
}

export type BundleDuplicatesResponse = BundleDuplicateItem[];

type GetBundleDuplicatesProps = {
  bundleId: string;
  abortController?: AbortController;
};

const getBundleDuplicatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleDuplicates: builder.query<BundleDuplicatesResponse, GetBundleDuplicatesProps>({
      query: ({ bundleId, abortController = new AbortController() }: GetBundleDuplicatesProps) => ({
        url: 'bundle/duplicates',
        method: 'GET',
        params: {
          bundleId: bundleId
        },
        signal: abortController.signal
      }),
      providesTags: (_result, _err, { bundleId }) => [{ type: BUNDLE_DUPLICATES_TAG, id: bundleId }]
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleDuplicatesQuery } = getBundleDuplicatesApi;
